import isIos from '@utilities/detect-os'

/**
 * Body lock utils to prevent body from scrolling on iOS when positioned fixed
 * Too prevent issues when having -webkit-overflow-scrolling: touch
 * Source: https://stackoverflow.com/questions/48873171/webkit-overflow-touch-stops-working-when-tapping-on-element-outside-of-scroll
 */

function touchMoveHandler() {
  document.body.scrollTop = 0
}

export const addBodyLock = () => {
  if (!isIos) return
  document.addEventListener('touchmove', touchMoveHandler, false)
}

export const removeBodyLock = () => {
  if (!isIos) return
  document.removeEventListener('touchmove', touchMoveHandler, false)
}
